import guideSerializer from '@serializers/guideSerializer.js'
import { KEYS_GUIDES } from '@config/storeKeys.js'
import { store } from '@stores'
import { computed } from 'vue'

const { addToStoreData, updateStore, generateId, getStore } = store()

export default function () {
  function addGuides(gameNameId, guides, query) {
    updateStore(generateId(KEYS_GUIDES, gameNameId), {
      ...guideSerializer.transform(guides),
      query,
    })
  }

  function getGuides(gameId) {
    return getStore(generateId(KEYS_GUIDES, gameId))
  }

  function addGuide(gameId, guide) {
    const _guide = guideSerializer.transform(guide)
    addToStoreData(generateId(KEYS_GUIDES, gameId), _guide)
    return _guide
  }

  function getGuide(gameId, guideNameId) {
    const guides = getStore(generateId(KEYS_GUIDES, gameId))

    return computed(() =>
      guides.value?.data?.find((guide) => guide.name_id === guideNameId)
    )
  }

  function removeGuides(gameId) {
    updateStore(generateId(KEYS_GUIDES, gameId))
  }

  return {
    removeGuides,
    addGuides,
    getGuides,
    getGuide,
    addGuide,
  }
}
